import { useEffect, useState } from 'react';

import { useRentalManagerUserExperimentWebApiHandler_getTreatment } from '@zg-rentals/ts-rental-manager-api-client-react-query';
import { getCookieAsBoolean } from '@zg-rentals/zillow-rental-manager/client';

import { ZRM_APPLICATIONS_OPT_IN_DRIVERS_ENABLED } from '../constants/FeatureFlagConstants';
import SplitTestConstants from '../constants/SplitTestConstants';

export const useApplicationsOptInDriversAccess = ({ enabled = true }: { enabled?: boolean } = {}): {
  isEnabled: boolean;
  isLoading: boolean;
} => {
  // Read after mount: during render the cookie is false on the server, mismatching on hydration.
  const [cookie, setCookie] = useState({ checked: false, enabled: false });

  useEffect(() => {
    setCookie({ checked: true, enabled: getCookieAsBoolean(ZRM_APPLICATIONS_OPT_IN_DRIVERS_ENABLED) });
  }, []);

  // Callers pass `enabled: false` where the feature can never show, so the treatment call does not count an exposure.
  const isQueryEnabled = enabled && cookie.checked && !cookie.enabled;

  const { data, isPending } = useRentalManagerUserExperimentWebApiHandler_getTreatment(
    { featureName: SplitTestConstants.ZRM_APPLICATIONS_OPT_IN_DRIVERS },
    {
      enabled: isQueryEnabled,
      staleTime: Infinity,
      throwOnError: false,
      meta: {
        tags: ['applications-opt-in-drivers-split-treatment'],
        context: {
          api: 'getTreatment',
          details: { featureName: SplitTestConstants.ZRM_APPLICATIONS_OPT_IN_DRIVERS },
        },
      },
    },
  );

  if (!enabled) {
    return { isEnabled: false, isLoading: false };
  }

  return {
    isEnabled: cookie.enabled || data?.treatment === 'on',
    isLoading: !cookie.checked || (isQueryEnabled && isPending),
  };
};
